var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var loaders = require('../../layout/components/loaders');
var copyModal = Object.create(Model);
var treeDashboardsAndLocations = require('../../components/treeDashboardsAndLocations');
var DestinationTypes = treeDashboardsAndLocations.DestinationTypes;


modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

function getRequestErrorMessage(error) {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error.error) return error.error;
  if (error.message) return error.message;
  if (error.body && error.body.error) return error.body.error;
  return '';
}


copyModal.editDialogue = function (record, options) {

  copyModal.showDashboardSelector = !(
    (record && record.useHasDashboardEdge) ||
    (options && options.useHasDashboardEdge)
  );
  copyModal.selection = prop({
    type: copyModal.showDashboardSelector ? DestinationTypes.DASHBOARD : DestinationTypes.LOCATION,
    record: {}
  });
  copyModal.deviceId = prop('')
  copyModal.device = prop('')
  copyModal.newDashboardName = prop('')
  copyModal.error = prop('');

  var submit = () => {
    copyModal.error('');
    var selection = copyModal.selection() || {};
    var targetNode = selection.record;

    if (!targetNode || !targetNode['@rid']) {
      copyModal.error('Please select a dashboard or location to copy this dashboard to.');
      return Promise.resolve();
    }

    if (selection.type === DestinationTypes.DASHBOARD && !copyModal.showDashboardSelector) {
      copyModal.error('Dashboards attached to locations can only be copied to locations.');
      return Promise.resolve();
    }

    var newDashboardName = (copyModal.newDashboardName() || '').trim();
    if (!newDashboardName) {
      copyModal.error('Dashboard name is required.');
      m.redraw();
      return Promise.resolve();
    }

    return loaders.requestWithLoader({
      loader: 'submit',
      url: "/api/v1/dashboard/template/copy",
      method: "POST",
      body: {
        originDashboardId: record['@rid'].slice(1),
        parentDashboardId: targetNode['@rid'].slice(1),
        deviceId: copyModal.deviceId(),
        newDashboardName: newDashboardName
      }
    })
    .then( response => {
      if(response.response == 'ok'){
        key.unbind('enter');
        return Promise.resolve(options && options.submitCallback ? options.submitCallback() : '')
        .then(function () {
          modal.vm.close();
          m.redraw();
        });
      }
    })
    .catch(function (error) {
      copyModal.error(getRequestErrorMessage(error) || 'Unable to copy the dashboard. Please try again.');
      m.redraw();
    });
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title('Copy Dashboard: ')
  modal.vm.body = copyModal.view,
  modal.vm.buttons([
    {
      label: "Save",
      class: "btn-good",
      func: submit
    }
  ]);
  modal.vm.open();
}


copyModal.view = function () {
  return m('form', {role:'form'}, [
    m(treeDashboardsAndLocations, {
      selector: copyModal.selection,
      showDashboards: copyModal.showDashboardSelector,
      showLocations: true,
      dashboardLabel: 'destination dashboard',
      onSelect: function () {
        copyModal.error('');
      }
    }),
    copyModal.error() ? m('div.red.mt2', copyModal.error()) : '',
    m('label.mt2', 'Device Id:'),
    m('input.form-control.mb2', {
      autocomplete: 'off',
      type:'text', 
      oninput: function(ev){copyModal.deviceId(ev.target.value)},
      value: copyModal.deviceId(),
    }),
    m('label.mt2', 'New Dashboard Name:'),
    m('input.form-control', {
      autocomplete: 'off',
      type:'text', 
      oninput: function(ev){copyModal.newDashboardName(ev.target.value)},
      value: copyModal.newDashboardName(),
    }),

  ])  
}

module.exports = copyModal;
